import React from "react";
import { IFooterCtaProps } from "./FooterCtaProps";
import { Wrapper } from "./FooterCtaHelpers";
import { useSelector } from "react-redux";
import { Link } from "gatsby";
import { useFooterCtaSliceContext } from "../../../context/SliceContexts/FooterCtaContext";

const FooterCta: React.FC<IFooterCtaProps> = () => {
  const isLoggedIn = useSelector((state: any) => state.member.isLoggedIn);
  const { field_title, field_link, relationships } = useFooterCtaSliceContext();
  const HR = "/join-travel-pass";
  const link = field_link;
  const logo =
    relationships.field_media &&
    relationships.field_media.relationships.field_media_file.publicUrl;
  const isHRAndLoggedIn = link && isLoggedIn && link.url.toLowerCase() === HR;
  return (
    <Wrapper className="p-3 rounded">
      <Link to={isLoggedIn ? "/account" : "/join-travel-pass"}>
        <img src={logo} alt={field_title} />
      </Link>
      <p>{field_title}</p>
      {link !== null && (
        <Link
          to={isHRAndLoggedIn ? "/account" : link.url}
          className="btn dark text-uppercase w-100"
        >
          {isHRAndLoggedIn ? "View Account" : link.title}
        </Link>
      )}
    </Wrapper>
  );
};

export default FooterCta;
